import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { of } from "rxjs";
import { catchError, filter, map, mergeMap, withLatestFrom } from "rxjs/operators";
import { OnboardingService } from "../../services/onboarding.service";
import { OnboardingState } from "../state/onboarding.state";
import { StateService } from "../../services/state.service";
import * as OnboardingActions from "../actions/onboarding.actions";
import * as OnbaordingSelectors from "../selectors/onboarding.selectors";
import * as ErrorActions from "../../../shared/store/actions/error.actions";
import * as LoaderActions from "../../../shared/store/actions/loader.actions";


@Injectable()
export class OnboardingEffects {
    constructor(
        private actions$: Actions,
        private onboardingService: OnboardingService,
        private store: Store<OnboardingState>,
        private stateService: StateService,
    ) { }

    getExtendedOnboardingTrainingDocuments$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(OnboardingActions.GetExtendedOnboardingTrainingDocuments),
            withLatestFrom(this.store.select(OnbaordingSelectors.GetExtendedOnboardingTrainingDocuments)),
            filter(([, state]) => state === null || state.length === 0),
            mergeMap(result => {
                const action = result[0];

                //  Increment loader count
                this.store.dispatch(new LoaderActions.IncrementLoaderCount());

                //  Send request to API
                return this.onboardingService.getTrainingDocuments('extended').pipe(
                    map(documents => {
                        //  Dispatch action to decause load count & return new success action
                        this.store.dispatch(new LoaderActions.DecrementLoaderCount());
                        return OnboardingActions.GetOnboardingTrainingDocumentsSuccess({ onboardingType: 'extended', documents });
                    }),
                    catchError(err => {
                        //  Dispatch action to decause load count & return new error action
                        this.store.dispatch(new LoaderActions.DecrementLoaderCount());
                        return of(new ErrorActions.PushError(err));
                    })
                )
            })
        )
    });

    getInitialOnboardingTrainingDocuments$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(OnboardingActions.GetInitialOnboardingTrainingDocuments),
            withLatestFrom(this.store.select(OnbaordingSelectors.GetInitialOnboardingTrainingDocuments)),
            filter(([, state]) => state === null || state.length === 0),
            mergeMap(result => {
                const action = result[0];

                //  Increment loader count
                this.store.dispatch(new LoaderActions.IncrementLoaderCount());

                //  Send request to API
                return this.onboardingService.getTrainingDocuments('initial').pipe(
                    map(documents => {
                        //  Dispatch action to decause load count & return new success action
                        this.store.dispatch(new LoaderActions.DecrementLoaderCount());
                        return OnboardingActions.GetOnboardingTrainingDocumentsSuccess({ onboardingType: 'initial', documents });
                    }),
                    catchError(err => {
                        //  Dispatch action to decause load count & return new error action
                        this.store.dispatch(new LoaderActions.DecrementLoaderCount());
                        return of(new ErrorActions.PushError(err));
                    })
                )
            })
        )
    });
}